import React, {useContext} from "react";
import GlobalContext from "../GlobalContext";

const YearNavigator = () => {

  const CONTEXT = useContext(GlobalContext);

  function createYearCells(setSelectedYear) {
    let ths = [];
    let th;
    let classes = " font-weight-bold color-text-white";

    for (let y = CONTEXT.eventsExtremeDates.newest; y >= CONTEXT.eventsExtremeDates.oldest; y--) {
      th = <th
        className={"border-top-0 cursor-pointer " + (CONTEXT.selectedYear === y ? classes.replace("color-text-white", "color-text-red") : classes)}
        onClick={() => setDate(setSelectedYear, y)}
        key={`ic-${y}`}
        data-year-number={y}
      >{y}</th>
      ths.push(th)
    }

    return ths;
  }

  function setDate(setSelectedYear, y) {
    setSelectedYear(y);
  }

  return (
    <div className="year-navigator overflow-x-auto overflow-y-hidden">
      <GlobalContext.Consumer>
        {({
            setSelectedYear
          }) => (
          <table className="mb-0 border-bottom">
            <thead>
            <tr>
              {createYearCells(setSelectedYear)}
            </tr>
            </thead>
          </table>
        )}
      </GlobalContext.Consumer>
    </div>
  );
};

export default YearNavigator;
